<template>
  <div>
    <b-modal
      title="Детали"
      id="modal-group-details"
      size="lg"
      @hide="resetModal"
      centered
      :hide-footer="true"
    >
      <b-row>
        <b-col cols="5">
          <b-row>
            <label class="mt-2">Назва</label>
            <b-form-input
              :disabled="readonlyInputs"
              v-model="group.name"
              class="mt-2"
            ></b-form-input>
          </b-row>
          <b-row>
            <label class="mt-2">Час</label>
            <b-form-input
              type="time"
              :disabled="readonlyInputs"
              v-model="group.daytime"
              class="mt-2"
            ></b-form-input>
          </b-row>
          <b-row>
            <label class="mt-2">Вартість візиту</label>
            <b-form-input
              v-model="group.visit_cost"
              type="number"
              :disabled="readonlyInputs"
              class="mt-2"
            ></b-form-input>
          </b-row>
          <b-row>
            <label class="mt-2">Тренер</label>
            <b-form-input
              v-if="!readonlyInputs"
              placeholder="Пошук"
              v-model="trainerSearch"
              class="mt-2"
            ></b-form-input>
            <b-form-select
              :disabled="readonlyInputs"
              :options="trainerOptions"
              v-model="group.trainer_id"
              class="mt-2 form-control"
            ></b-form-select>
          </b-row>
          <b-row>
            <label class="mt-2">Клуб</label>
            <b-form-select
              :disabled="readonlyInputs"
              :options="clubOptions"
              v-model="group.club_id"
              class="mt-2 form-control"
            ></b-form-select>
          </b-row>
          <b-row>
            <label class="mt-2">Опис</label>
            <b-form-textarea
              :disabled="readonlyInputs"
              v-model="group.description"
              class="mt-2"
            ></b-form-textarea>
          </b-row>
        </b-col>
        <b-col cols="6">
          <b-row>
            <b-button
              v-if="user[0].role === 'superadmin' && readonlyInputs"
              variant="outline-success ms-5 mt-4"
              v-on:click="toggleInputs()"
            >
              Редагувати
            </b-button>
            <b-button
              v-if="user[0].role === 'superadmin' && !readonlyInputs"
              variant="primary ms-5 mt-4"
              v-on:click="patchGroup()"
            >
              Зберегти
            </b-button>
          </b-row>
          <b-row>
            <b-button
              v-if="user[0].role === 'superadmin'"
              v-on:click="deleteGroup"
              variant="danger ms-5 mt-5"
            >
              Видалити
            </b-button>
          </b-row>
          <b-row>
            <b-button
              v-if="user[0].role === 'superadmin'"
              class="mt-4 ms-5"
              variant="success"
              v-on:click="addGroupDay"
              :disabled="!newWeekDay"
            >
              Додати
              <b-icon
                class="ms-1"
                icon="plus-circle"
                v-if="!readonlyInputs"
              ></b-icon>
            </b-button>
            <b-form-select
              class="mt-4 ms-5 form-control"
              :disabled="readonlyInputs"
              v-if="!readonlyInputs"
              v-model="newWeekDay"
              :options="weekdays"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >Оберіть дні тижня</b-form-select-option
                >
              </template>
            </b-form-select>
            <div
              class="group-list mt-4 ms-5"
              v-if="group.group_days && group.group_days.length"
            >
              <!--            <h5 class="mt-4">Дни : </h5>-->
              <b-table
                class="mt-2"
                :items="group.group_days"
                :fields="tableControls"
              >
                <template #cell(name)="row">
                  {{ toLocale(row.item.name) }}
                </template>
                <!--              <template #cell(delete)="row">-->
                <!--                <b-icon-->

                <!--                    icon="x-circle"-->
                <!--                    variant="danger"-->
                <!--                    @click="deleteOutcome(row.item.outcome)">-->

                <!--                </b-icon>-->
                <!--              </template>-->
              </b-table>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import Alert from "@/components/Toasts/Alert";

export default {
  name: "GroupDetails",
  props: {
    group: {},
  },
  components: {
    Alert,
  },
  data: function () {
    return {
      readonlyInputs: true,
      activErr: false,
      AlertText: "",
      class: "",
      dayOptions: [],
      authConfig: {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      },
      formattedTrainers: [],
      trainerSearch: "",
      newWeekDay: null,
      clubOptions: [
        { value: 1, text: "Василенко, 9" },
        { value: 2, text: "Острозького, 55" },
      ],
      weekdays: [
        { value: 1, text: "Понеділок" },
        { value: 2, text: "Вівторок" },
        { value: 3, text: "Середа" },
        { value: 4, text: "Четвер" },
        { value: 5, text: "П'ятниця" },
        { value: 6, text: "Субота" },
        { value: 7, text: "Неділя" },
      ],
    };
  },
  watch: {
    trainerSearch: function (newVal) {
      console.log(this.group);
      if (newVal === "" || !newVal) {
        this.formattedTrainers = this.trainers;
      } else {
        let filtered = [];
        this.trainers.forEach((trainer) => {
          if (
            trainer.name.includes(this.capitalizeFirstLetter(newVal)) ||
            trainer.surname.includes(this.capitalizeFirstLetter(newVal))
          ) {
            filtered.push(trainer);
          }
        });
        this.formattedTrainers = filtered;
      }
    },
  },
  computed: {
    ...mapState(["trainers", "user"]),
    trainerOptions: function () {
      let options = [];
      this.formattedTrainers.forEach((trainer) => {
        options.push({
          value: trainer.id,
          text: trainer.name + " " + trainer.surname,
        });
      });
      console.log(options);
      return options;
    },
    tableControls: function () {
      // if (this.user[0].role === 'superadmin') {
      //   return [
      //     {key: 'name', label: 'Дни'},
      //     {key: 'delete', label: 'Удаление'}
      //   ]
      // } else {
      return [{ key: "name", label: "Дні" }];
      // }
    },
  },
  async mounted() {
    await this.getTrainerList();
    this.formattedTrainers = this.trainers;
  },
  methods: {
    ...mapActions(["setClubTrainers", "logOutUser"]),
    async getTrainerList() {
      await axios
        .get(`${process.env.VUE_APP_API}/trainers/get/`, this.authConfig)
        .then((response) => {
          this.setClubTrainers(response.data.Message.Trainers);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    async patchGroup() {
      this.toggleInputs();
      let payload = {
        name: this.group.name,
        visit_cost: this.group.visit_cost,
        daytime: this.group.daytime,
        trainer_id: this.group.trainer_id,
        location: this.group.club_id,
        description: this.group.description,
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/staticschedule/patch/${this.group.id}`,
          payload,
          this.authConfig,
        )
        .then((response) => {
          this.group = response.data;
          this.showModalCreate("Група успішно оновлена", "green");
          this.trainerSearch = "";
          this.formattedTrainers = this.trainers;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else if (err.response.status === 403) {
            this.showModalCreate("Недостатньо прав", "yellow");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            this.showModalCreate("Щось пішло не так.", "red");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        });
    },
    async deleteGroup() {
      let result = confirm(`Видалити групу ${this.group.name}?`);
      if (!result) {
        return;
      }
      await axios
        .delete(
          `${process.env.VUE_APP_API}/staticschedule/delete/${this.group.id}`,
          this.authConfig,
        )
        .then((response) => {
          alert(response.data.toString());
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else if (err.response.status === 403) {
            this.showModalCreate("Недостатньо прав", "yellow");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            this.showModalCreate("Щось пішло не так.", "red");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    resetModal() {
      this.formattedTrainers = this.trainers;
      this.trainerSearch = "";
      this.readonlyInputs = true;
      this.newWeekDay = null;
    },
    async addGroupDay() {
      let group_id = this.group.id;
      this.toggleInputs();
      let newDay = this.weekdays.find((day) => {
        return day.value === this.newWeekDay;
      });
      let result = confirm(`Добавити ${newDay.text} у дні заняття?`);
      if (!result) {
        return;
      }
      this.group.group_days.push({
        id: newDay.value,
        name: this.toLocale(newDay.text),
      });
      let payload = {
        days: this.group.group_days,
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/staticschedule/days/${this.group.id}`,
          payload,
          this.authConfig,
        )
        .then(async (response) => {
          this.group = response.data;
          this.showModalCreate("Група успішно оновлена", "green");
          this.trainerSearch = "";
          this.formattedTrainers = this.trainers;
          this.newWeekDay = null;
          await this.getGroup(group_id);
          // setTimeout(() => {window.location.reload()}, 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else if (err.response.status === 403) {
            this.showModalCreate("Недостатньо прав", "yellow");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            this.showModalCreate("Щось пішло не так.", "red");
            // setTimeout(() => {window.location.reload()}, 3000);
          }
        });
    },
    async getGroup(group_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/staticschedule/group/${group_id}`,
          this.authConfig,
        )
        .then((response) => {
          this.group = response.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else {
            this.showModalCreate("Щось пішло не так", "red");
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        });
    },
    toggleInputs() {
      this.readonlyInputs = !this.readonlyInputs;
    },
    toLocale: function (day) {
      if (day === "Monday") {
        return "Понеділок";
      } else if (day === "Tuesday") {
        return "Вівторок";
      } else if (day === "Wednesday") {
        return "Середа";
      } else if (day === "Thursday") {
        return "Четвер";
      } else if (day === "Friday") {
        return "П'ятниця";
      } else if (day === "Saturday") {
        return "Субота";
      } else if (day === "Sunday") {
        return "Неділя";
      } else {
        return day;
      }
    },
  },
};
</script>

<style scoped></style>
